import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../environments/environment";
import {PriceList} from "../interface/price-list";

@Injectable({
  providedIn: 'root'
})
export class PriceListService {

  private baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  get(id: number): Observable<any>{
    return this.http.get(`${this.baseUrl}/get/price-list/${id}`);
  }
  getCollection(): Observable<PriceList[]>{
    return this.http.get<PriceList[]>(`${this.baseUrl}/get/price-list`);
  }

  post(data: PriceList): Observable<any>{
    return this.http.post<PriceList>(`${this.baseUrl}/create/price-list`, data);
  }

  put(id: number, data: PriceList): Observable<any>{
    return this.http.put<PriceList>(`${this.baseUrl}/edit/price-list/${id}`, data);
  }

  delete(id: number): Observable<PriceList>{
    return this.http.delete<PriceList>(`${this.baseUrl}/delete/price-list/` + id);
  }

  deleteMultiple(ids: number[]): Observable<PriceList[]>{
    const options = {body: ids};
    return this.http.delete<PriceList[]>(`${this.baseUrl}/delete/selected/price-list`, options);
  }

}
